<template>

   <div class="bg-theme-gray-8" style="display:none;">
      <div class="relative" :class="layout == 'full-width' ? 'w-full' : 'w-[80%] mx-auto lg:w-theme-dw'">
         <div class="bg-center bg-no-repeat bg-cover" :class="bannerClass"></div>
         <div class="bg-[#858C9266] w-full h-full absolute top-0 left-0"></div>
         <div class="absolute top-0 left-0 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-4 w-full">
            <h1 class="text-head-md md:text-head-xxl text-white font-light">{{ heading }}</h1>
            <div class="text-white text-size-1 md:text-size-2 flex flex-row items-center gap-3">
               <div @click="router.push({ name: 'Home' })" class="uppercase hover:underline cursor-pointer">Home</div> |
               <div class="uppercase">{{ currentPage }}</div>
            </div>
         </div>
      </div>
   </div>

</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const props = defineProps(['layout', 'currentPage', 'heading', 'bannerClass'])
const router = useRouter()
</script>